/**
 * Cart Upsell Component
 * 
 * This component handles cart upsell functionality by:
 * - Listening to cart update events
 * - Updating upsell block HTML based on cart changes
 */

class CartUpsell extends HTMLElement {
  constructor() {
    super();
    
    this.upsellContainer = this.querySelector('[data-cart-upsell]');
    this.isUpdating = false;
    
    this.init();
  }

  /**
   * Initialize the component
   */
  init() {
    if (!this.upsellContainer) return;
    
    // Subscribe to cart update events
    this.unsubscribeCartUpdate = eventBus.subscribe(THEME_EVENTS.cartUpdate, this.handleCartUpdate.bind(this));
  }

  /**
   * Handle cart update events
   * @param {Object} eventData - Cart update event data
   */
  handleCartUpdate(eventData) {
    if (this.isUpdating) return;
    
    this.isUpdating = true;
    
    try {
      const { action, section } = eventData.data;
      
      // Update upsell block HTML if needed
      if(action == 'remove-item' || action == 'add-item') this.updateUpsellHTML(section);
    } catch (error) {
      console.error('Error handling in upsell component:', error);
    } finally {
      this.isUpdating = false;
    }
  }

  /**
   * Update upsell HTML with new content
   * @param {string} newHTML - New HTML content
   */
  updateUpsellHTML(newHTML) {
    if (!newHTML || !this.upsellContainer) return;
    
    const parsedHTML = ((typeof newHTML == 'string') ? Utility.DOM.parse(newHTML) : newHTML);
    const newUpsellContainer = parsedHTML.querySelector('[data-cart-upsell]');
    if (!newUpsellContainer) return;

    // Update the container content
    const hasProducts = newUpsellContainer.querySelector('[data-upsell-item]')?.children.length > 0;
    this.classList.toggle('d-none', !hasProducts);
    if (!hasProducts) return;

    this.upsellContainer.innerHTML = newUpsellContainer.innerHTML;
    lazyImageObserver.observe();

    // Trigger swiper load if swiper-container is present in the loaded content
    // This ensures swiper bundle loads even if it wasn't present on initial page load
    if (typeof window.triggerSwiperLoad === 'function') {
      window.triggerSwiperLoad();
    }
  }

  /**
   * Clean up event listeners
   */
  disconnectedCallback() {
    if (this.unsubscribeCartUpdate) {
      this.unsubscribeCartUpdate();
    }
  }
}

// Register the custom element
customElements.define('cart-upsell', CartUpsell);
